import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Layout = ({ children }) => {
 
  return (
    <div style={styles.container}>
      <Header />
      <main style={{ padding: '20px' }} className='content'>
        {children}
      </main> 
      <Footer />
    </div>
  );
};

const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    },
    main: {
      flex: 1,
      padding: '20px',
      // Responsive padding
      '@media (max-width: 768px)': {
        padding: '10px',
      },
    },
  };

export default Layout;
